<template>
    <div
        :class="{ [$style.wrapper]: true, [$style[verticalFlow]]: true }"
        :style="wrapperStyle"
    >
        <div :class="$style.inner" :style="innerStyle">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        closeOnNextClick: Boolean,
        closeOnOutsideClick: Boolean,
        coords: Object,
        width: Number,
        verticalFlow: String,
        verticalOffset: Number,
        horizontalFlow: String,
        horizontalOffset: Number,
        handleClass: {
            type: String,
            default: () =>
                'popup-menu-' + Math.random().toString(36).substring(7),
        },
    },
    emits: ['close'],
    data() {
        return {
            listener: null,
        };
    },
    computed: {
        wrapperStyle() {
            return {
                top: `${this.coords.top}px`,
                left: `${this.coords.left}px`,
            };
        },
        innerStyle() {
            const vertical = this.verticalFlow === 'up' ? 'bottom' : 'top';
            const horizontal =
                this.horizontalFlow === 'right' ? 'left' : 'right';

            return {
                [vertical]: `${this.verticalOffset}px`,
                [horizontal]: `${this.horizontalOffset}px`,
                width: `${this.width}px`,
            };
        },
    },
    mounted() {
        this.$el.parentElement.classList.add(this.handleClass);

        this.listener = e => {
            if (this.shouldClose(e.target)) {
                this.$emit('close');
            }
        };

        window.addEventListener('click', this.listener);
    },
    destroyed() {
        window.removeEventListener('click', this.listener);
    },
    methods: {
        shouldClose(element) {
            return (
                this.closeOnNextClick ||
                (this.closeOnOutsideClick &&
                    !element.closest(`.${this.handleClass}`))
            );
        },
    },
};
</script>

<style lang="scss" module>
.wrapper {
    position: absolute;

    &.up {
        .inner {
            bottom: 0;
        }
    }
    &.down {
        .inner {
            top: 0;
        }
    }
}
.inner {
    @extend %popup;
    position: absolute;
    margin-top: 2px;
    padding-top: 3px;
    padding-bottom: 3px;
    text-align: left;
    z-index: 1000000000000000;
}
</style>

<style lang="scss">
.popup-menu-item {
    padding: 4px 8px 4px 8px;

    &:hover {
        cursor: pointer;
        background-color: #f0f0f0;
    }
}
</style>
